type FilledField = {
  id: string;
  value: unknown;
  created_at: string;
  updated_at: string;
  correction?: {
    status: string;
    comments?: Array<{
      text: string;
      creator?: { name: string; last_name: string };
    }>;
  } | null;
  [key: string]: unknown;
};

export function getLastFilledFieldWithCorrection(
  filledFields: FilledField[] | undefined,
): FilledField | undefined {
  if (!filledFields || filledFields.length === 0) return undefined;
  const lastWithCorrection = [...filledFields]
    .reverse()
    .find((ff) => ff.correction);
  return lastWithCorrection || filledFields.at(-1);
}
